export default __webpack_public_path__ + "media/images/celeste_mountain-d6e39269d99eb9e56dd56bf822dcb1ab.png";